import { Injectable } from '@angular/core';

import { NativeBiometricsProvider } from './native-biometrics';
import { NativeLiquidGlassBarProvider } from './native-liquid-glass-bar';

@Injectable()
export class NativeProvider {
  biometrics: NativeBiometricsProvider;
  liquidGlassBar: NativeLiquidGlassBarProvider;

  constructor(
    private nativeBiometrics: NativeBiometricsProvider,
    private nativeLiquidGlassBar: NativeLiquidGlassBarProvider,
  ) {
    this.biometrics = nativeBiometrics;
    this.liquidGlassBar = nativeLiquidGlassBar;
  }
}



// WEBPACK FOOTER //
// ./src/providers/native/native.ts